import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AlignedAccelerator } from '../aligned-accelerators.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AlignedAccelerator, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId, { header: 'AccId', hidden: true }),
		buildColumn(util, 'Text', row => row.accName, { header: 'Accelerator', hidden: false, width: 70 }),
		buildColumn(util, 'Text', row => row.facilitatorName, { header: 'Facilitator', hidden: false }),
		buildColumn(util, 'YesNo', row => row.seatOffered, { header: 'Seat Offered', width: 80 }),
		buildColumn(util, 'Text', row => row.canAttend ? "Yes" : 'No', {
			header: 'Can Attend', hidden: true, width: 80,
			group: 'desc'
		}),
		buildColumn(util, 'Number', row => row.availableSeatCount, { header: 'Available Seats', width: 90 }),
		buildColumn(util, 'Number', row => row.seatsOffered, { header: 'Offered Seats', width: 90 }),
		buildColumn(util, 'Number', row => row.seatsAccepted, { header: 'Accepted Seats', width: 90 }),
		buildColumn(util, 'Number', row => row.gravityMiles, { header: 'Gravity Miles', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.meetingLocalDisplayText, { header: 'Session Time (local time)', headerTooltip: 'Time is shown in the time zone of your current location' }),
		buildColumn(util, 'Text', row => row.meetingAcceleratorDisplayText, { header: 'Session Time (accelerator time)', headerTooltip: 'Time is shown in the time zone of the accelerator', hidden: true }),
		buildColumn(util, 'Text', row => row.languageId == LanguageId.Espanol ? 'Spanish' : 'English', { header: 'Language', hidden: true, }),
	];


	return columns;

}